import React, { Component } from "react";
import { connect } from "react-redux";

import PageNavigator from "./PageNavigator";
import PageJumpLabel from "./PageJumpLabel";
import { goToPage } from "../actions/globalPaginationActions";
import { numberWithCommas } from "../utilities/utilities";

class GlobalPagination extends Component {
	render() {
		return (
			<div className="GlobalPagination">
				<PageNavigator
					page={this.props.currentPage}
					totalPages={this.props.totalPages}
					onChange={this.props.goToPage}
					style={{ marginRight: 15 }}
				/>
				<div className="PaginationSummary">
					<PageJumpLabel
						page={this.props.currentPage}
						totalPages={this.props.totalPages}
						onChange={this.props.goToPage}
						style={{ marginRight: 8 }}
					/>
					<span>
						{" "}
						{`(${
							this.props.isFiltered
								? "Results based on your filter: " +
									numberWithCommas(this.props.filteredCount) +
									" of "
								: ""
						}${numberWithCommas(
							this.props.totalResults
						)} total items)`}
					</span>
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		currentPage: state.pagination.currentPage,
		totalPages: state.pagination.totalPages,
		resultsPerPage: state.pagination.resultsPerPage,
		totalResults: state.pagination.totalResults,
		filteredCount: state.pagination.filteredCount,
		isFiltered: state.pagination.filteredCount > -1,
	};
};
export default connect(mapStateToProps, { goToPage })(GlobalPagination);
